import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { useContext } from 'react';
import { CommonContext } from '../../context/CommonContext';
import { ProjectsContext } from '../../context/ProjectsContext';
import ProjectsTable from './ProjectsTable';

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const ProjectsDialog = ({ open, handleClose }: any) => {
  const { setAlertMessage, setLoading, setLoadingText } = useContext(CommonContext);
  const { projects, removeProjects, exportProject } = useContext(ProjectsContext);

  const exportProjects = async (exportProjects: {
    id: number;
    name: string;
  }[]) => {
    try {
      setLoading(true);

      for (let i = 0; i < exportProjects.length; i++) {
        const project = exportProjects[i];

        setLoadingText(`Exporting project ${i + 1} of ${exportProjects.length}`);

        await new Promise<void>((resolve) => {
          exportProject(project.id, () => {
            resolve();
          }, project.name);
        });

        // small delay between exports
        await delay(300);
      }

      setAlertMessage('Projects exported successfully');
    } catch (err) {
      setAlertMessage('Export failed');
    } finally {
      setLoadingText('');
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
      <DialogContent>
        <ProjectsTable
          rows={projects}
          removeProjects={removeProjects}
          exportProjects={exportProjects}
          setAlertMessage={setAlertMessage}
          handleClose={handleClose}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectsDialog;
